<template>
  <div class="logo flex flex-wrap items-end cursor-pointer" @click="goHome">
    <img src="@/assets/images/logo/metaLogo.svg" alt="" class="w-full">
  </div>
</template>

<script>

import {EventBus} from '../../EventBus'

export default {
  name: 'Logo',
  components: {},
  methods: {
    goHome () {
      EventBus.$emit('scrollTo')
    }
  }
}
</script>

<style scoped lang="scss">
div {
  .logo {
    @media screen and (max-width: 1024px) {
      width: 112px;
    }
  }
}

</style>
